<template>
  <el-row class="bids-filter">
    <el-col :span="24">
      <el-link type="primary" @click.prevent="filterByStatus(2)">
        ОТКАЗАНО ({{ counts.disapproved }})
      </el-link>
    </el-col>
    <el-col :span="24">
      <el-link type="primary" @click.prevent="filterByStatus(0)">
        ЖДУТ УТВЕРЖДЕНИЯ ({{ counts.not_approved }})
      </el-link>
    </el-col>
    <el-col :span="24">
      <el-link type="primary" @click.prevent="filterByStatus(1)">
        УТВЕРЖДЕНЫ ({{ counts.approved }})
      </el-link>
    </el-col>
    <el-col :span="24">
      <el-link type="danger" @click.prevent="filterByStatus(3)">
        УДАЛЕННЫЕ ({{ counts.deleted }})
      </el-link>
    </el-col>
    <el-col :span="24">
      <el-link type="success" @click.prevent="filterByStatus(null)">
        ВСЕ ({{ counts.total }})
      </el-link>
    </el-col>
  </el-row>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'BidsListFilter',
  computed: {
    ...mapGetters('loadDay', ['getStats']),
    counts() {
      return this.getStats('counts')
    },
  },
  methods: {
    filterByStatus(status) {
      this.$emit('update', status)
    },
  },
}
</script>

<style scoped lang="sass">
.bids-filter
  &>div
    text-align: right
    &:first-child .el-link
      margin-top: 20px
  & .el-link
    margin: 6px 0
    font-weight: 600
    border-bottom: 1px solid #409EFF
  & .el-link.el-link--success
    border-bottom: 1px solid #67C23A
  & .el-link.el-link--danger
    border-bottom: 1px solid #F56C6C
.bids-dop-menu
  &>div
    text-align: right
</style>
